import { render, staticRenderFns } from "./FavoriteIndicator.vue?vue&type=template&id=03cc8f12&scoped=true"
import script from "./FavoriteIndicator.vue?vue&type=script&lang=js"
export * from "./FavoriteIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc8f12",
  null
  
)

export default component.exports